
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `點擊「在瀏覽器中打開…」`,
's182ab2d6c997515f': `將其加入主屏幕，以獲得更豐富的體驗和便捷訪問。`,
's224cbcec014ef6b5': `點擊列表上的分享按鈕`,
's233af3b7eb5e0364': `添加到主頁`,
's37a9e8aec5713460': `詳細資訊`,
's4c3161035f3a1413': `請點擊菜單`,
's4e1e10a6ca408245': `點擊「添加到主屏幕」`,
's6196153c4b0c1ea0': `安裝`,
's633502f7cff4f847': `打開您的瀏覽器菜單`,
's681e399d63311fba': `顯示圖庫`,
's6d14a4f70ba4e3cf': `如果沒有分享圖標，請點擊菜單`,
's922329d6f6213590': `添加到Dock欄`,
's9c63a79ffcc2a3a3': `點擊「添加到主屏幕」`,
'sa2d71bfd9525168d': `點擊「添加到Dock欄」`,
'sa5ef80b4bb9b39f8': `簡短資訊`,
'sb527eca1c1d7e7be': `打開應用程式內的瀏覽器菜單`,
'sba52286c21552a4e': `在您的裝置上安裝它，以獲得更豐富的體驗和便捷訪問。`,
'sc16e00a7a8b2fde2': `返回`,
'scdaf4bbff76674c8': `將App加入主畫面`,
'sd18a5b85f599ff3c': `在 Safari 中打開已複製的連結`,
'se72fc3a84f9b51c3': `點擊以複製連結`,
'se740f75b95a51807': `將其加入你的Dock欄，以獲得更豐富的體驗和便捷訪問。`,
'sfa6c42cdf48d93d2': `但此瀏覽器不支援此功能。請在外部瀏覽器中開啟連結以繼續。`,
'sfb78526365796a41': `在分享菜單中點擊「查看更多」`,
'sfea652f6580ff086': `此網站具有應用程式功能。`,
    };
  